/**
 * @type module
 * Przechowuje tablicę zaznaczonych filtrów,
 * udostępnia funkcje pozwalające na modyfikację tej tablicy oraz
 * pobranie obecnie wybranych filtrów, dodatkowo aktualizuje widok
 */

app.service('shopLocatorFilters', function() {
		var $filters, $deliveryOptions, selectedFilters = [];

	function clear( index ) {
		if( typeof index !== 'undefined' ) {
			removeFilter( index );
		} else {
			selectedFilters = [];
		}
		updateView();
	}

	function set( index ) {
		addFilter( index );
		updateView();
	}

	function addFilter( value ) {
		selectedFilters.push( value );
	}

	function removeFilter( value ) {
		var index = selectedFilters.indexOf( value );
		selectedFilters.splice( index, 1 );
	}

	function getSelectedFilters() {
		return selectedFilters;
	}

	function updateView() {
		$deliveryOptions.removeClass( 'active-option' );
		$filters.prop( 'checked', false );

		selectedFilters.forEach(function( index ) {
			$deliveryOptions.filter('[data-index="' + index + '"]').addClass( 'active-option' );
			$filters.filter('[data-index="' + index + '"]').prop('checked', true);
		});
	}

	function init($self) {
		$filters = $('.js-filter-menu', $self);
		$deliveryOptions = $('.js-delivery-option', $self);
	}

	return {
		init: init,
		set: set,
		clear: clear,
		getSelected: getSelectedFilters
	};

});
